import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux/es/hooks/useSelector";
import classes from './ChatTab.module.css';
import { API_ENDPOINT } from "../../services/api/resources";
import axios from "axios";

// icon import
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import ManageAccountsRoundedIcon from '@mui/icons-material/ManageAccountsRounded';
import PeopleAltRoundedIcon from '@mui/icons-material/PeopleAltRounded';
import { AttachEmail, ForumOutlined, SearchRounded } from "@mui/icons-material";
import Attachment from "../../components/common/Attachment/Attachment";
import AttachmentList from "../../components/common/AttachmentList/AttachmentList";

const Chat_System = () => {

    const loginData = useSelector((state) => state.loginData.value);

    const [buyer_token] = useState(loginData?.user?.token);
    const [auth_token] = useState(loginData?.auth_token);
    const [user_token] = useState(loginData?.user?.user_token);
    const [accessType] = useState(loginData?.access_type)

    const [getuserlist, setUserList] = useState([]);
    const [allmessages, setAllMessages] = useState([]);
    const [activeTab, setActiveTab] = useState("Users");
    const [selectedchat, setSelectedChat] = useState(null);
    const [isDownloading, setIsDownloading] = useState(false);
    const [conversationMessages, setConversationMessages] = useState([]);
    const [getuserinput, setUserInput] = useState({ message: "", file: null, fileName: "" });


    const [openRFQs, setOpenRFQs] = useState([]);


    const getAllUserList = async () => {
        try {
            const response = await axios.post(
                `${API_ENDPOINT.all_user_list}`,
                { buyer_token },
                { headers: { Authorization: `Bearer ${auth_token}` } }
            );
            const filteredUsers = response.data.filter(items => items.token !== user_token)
            console.log(filteredUsers)
            setUserList(filteredUsers);
        } catch (error) {
            console.error("Error fetching user list:", error);
        }
    };

    const getAllMessages = async () => {
        const formData = new FormData();
        formData.append("sender_token", user_token);

        try {
            const response = await axios.post(
                `${API_ENDPOINT.get_chat_messages}`,
                formData,
                { headers: { Authorization: `Bearer ${auth_token}` } }
            );
            setAllMessages(response.data);
        } catch (error) {
            console.error("Error fetching messages:", error);
        }
    };

    useEffect(() => {
        // const interval = setInterval(()=>{
        getAllUserList();
        getAllMessages();
        // },2000)
        // return ()=>clearInterval(interval)
    }, []);


    const filteredUsers = getuserlist.filter(user => {
        if (activeTab === "Users") return user.role === "User";
        if (activeTab === "Buyers") return user.role === "Buyer";
        if (activeTab === "RFQ") return user.rfq_id !== null;
        return false;
    });



    const handlerespectiveChat = async (person, sender_token, receiver_token, rfq_id = null) => {
        let usertokens = {};

        if (rfq_id) {
            // Handle RFQ-based chat
            usertokens = {
                sender_token: sender_token,
                receiver_token: receiver_token,
                rfq_id: rfq_id
            };

            // Set selected chat with RFQ details
            setSelectedChat({
                sender_token,
                receiver_token,
                rfq_id,
                first_name: getuserlist.find(i => i.token === receiver_token)?.first_name ?? "Unknown",
            });

        } else {
            // Handle normal direct messages
            usertokens = {
                sender_token: user_token,
                receiver_token: person.token
            };

            // Set selected chat for normal users
            setSelectedChat({
                token: person.token,
                first_name: person.first_name,
            });
        }

        try {
            const response = await axios.post(
                `${API_ENDPOINT.get_chat_messages}`,
                usertokens,
                { headers: { Authorization: `Bearer ${auth_token}` } }
            );


            const filteredMessages = response.data.filter(msg => msg.rfq_id == rfq_id)


            setConversationMessages(filteredMessages);
        } catch (error) {
            console.error("Error fetching conversation messages:", error);
        }
    };


    const handleUserMessageInput = (evt) => {
        const inputVal = evt.target.value;
        setUserInput({ ...getuserinput, message: inputVal });
    };

    const handleUserSendMessage = async () => {


        // const receiver_data = {
        //     sender_token: user_token,
        //     receiver_token: selectedchat.receiver_token ? selectedchat.receiver_token : selectedchat.token,
        //     sender_role: accessType,
        //     message: getuserinput.message,
        //     rfq_token: selectedchat?.rfq_id ? selectedchat.rfq_id : ''
        // }

        if (!getuserinput.message && !getuserinput.file) return; // Prevent sending empty messages

        const formData = new FormData();
        formData.append("sender_token", user_token);
        formData.append("receiver_token", selectedchat.receiver_token ? selectedchat.receiver_token : selectedchat.token);
        formData.append("sender_role", accessType);
        formData.append("message", getuserinput.message)
        formData.append("rfq_token", selectedchat?.rfq_id ? selectedchat.rfq_id : '')


        if (getuserinput.file) {
            formData.append("rfq_doc", getuserinput.file); // Correctly append the file
        } else {
            console.warn("No file selected");
        }


        const res = await axios.post(API_ENDPOINT.user_chat_message, formData, {
            headers: {
                Authorization: `Bearer ${auth_token}`,
                "Content-Type": "multipart/form-data",
            },
        });


        setConversationMessages(prev => [
            ...prev,
            {
                sender_token: user_token,
                receiver_token: selectedchat.token,
                attachment: getuserinput.file ? URL.createObjectURL(getuserinput.file) : null,
                fileName: getuserinput.file ? getuserinput.file.name : null,
                message: getuserinput.message,
                created: new Date().toLocaleString(),
                isSender: true,
            },
        ]);
        setUserInput({ message: "", file: null, fileName: "" });

    }


    const TransformMessages = (messages, user_token, getuserlist) => {
        return useMemo(() => {
            const result = {};

            for (const message of messages) {
                const { rfq_id, receiver_token, sender_token, name, designation } = message;


                let curr_sender_token, curr_receiver_token;

                if (receiver_token === user_token) {
                    curr_sender_token = user_token;
                    curr_receiver_token = sender_token;
                } else if (sender_token === user_token) {
                    curr_sender_token = sender_token;
                    curr_receiver_token = receiver_token;
                } else {
                    curr_sender_token = receiver_token;
                    curr_receiver_token = sender_token;
                }

                if (!rfq_id) continue;

                if (!result[rfq_id]) {
                    result[rfq_id] = [];
                }

                let userRef = result[rfq_id].find(entry =>
                    ((entry.sender_token === curr_sender_token) && (entry.receiver_token === curr_receiver_token)) ||
                    ((entry.sender_token === curr_receiver_token) && (entry.receiver_token === curr_sender_token))
                );

                if (!userRef) {
                    userRef = {
                        sender_token: curr_sender_token,
                        receiver_token: curr_receiver_token,
                        name: getuserlist.find(i => i.token === curr_receiver_token)?.first_name ?? "Unknown",
                        designation: getuserlist.find(i => i.token === curr_receiver_token)?.designation ?? "Unknown",
                        rfq_id: rfq_id,
                        messages: [],
                    };
                    result[rfq_id].push(userRef);
                }

                userRef.messages.push({
                    sender_token: sender_token,
                    sender: name,
                    receiver_token: receiver_token,
                    receiver: getuserlist.find(i => i.token === receiver_token)?.first_name ?? "Unknown",
                    message: message.message,
                    rfq_id: rfq_id,
                    status: message.status,
                    created: message.created
                });
            }

            return result;
        }, [messages, user_token, getuserlist]);
    };



    const final_data = TransformMessages(allmessages, user_token, getuserlist);



    const toggleAccordion = (rfq_id) => {
        setOpenRFQs((prev) =>
            prev.includes(rfq_id)
                ? prev.filter((id) => id !== rfq_id)
                : [...prev, rfq_id]
        );
    };


    useEffect(() => {
        setSelectedChat(null)
        setConversationMessages([])
    }, [activeTab])






    return (

        <div className={ classes.chatwrapper }>
            <div className={ classes.chatcontainer }>
                <div className={ classes.chatsidebar }>
                    <div className={ classes.optionbtncontainer }>
                        <button className={ `${activeTab === "Users" ? classes.activetabbtn : classes.optioncontainerbutton}` } onClick={ () => setActiveTab('Users') }>
                            <AccountCircleRoundedIcon sx={ { fontSize: 28 } } />

                            <span>Users</span>
                        </button>
                        <button className={ `${activeTab === 'Buyers' ? classes.activetabbtn : classes.optioncontainerbutton}` } onClick={ () => setActiveTab('Buyers') }>
                            <ManageAccountsRoundedIcon sx={ { fontSize: 28 } } />

                            <span>Buyers</span>
                        </button>
                        <button className={ `${activeTab === 'RFQ' ? classes.activetabbtn : classes.optioncontainerbutton}` } onClick={ () => setActiveTab('RFQ') }>
                            <PeopleAltRoundedIcon sx={ { fontSize: 28 } } />

                            <span>RFQ</span>
                        </button>
                    </div>
                    <div className={ classes.usercontainer }>

                        {/* <div className={classes.broadcastContainer}>
                            <input
                                type="text"
                                placeholder={`Broadcast message to ${activeTab}...`}
                                value={broadcastMessage}
                                onChange={(e) => setBroadcastMessage(e.target.value)}
                                className={classes.broadcastInput}
                            />
                            <button className={classes.broadcastButton} onClick={handleBroadcastMessage}>
                            <button className={classes.broadcastButton} >
                                Send
                            </button>
                        </div> */}


                        {/* <div className={classes.searchContainer}>

                            <SearchRounded className={classes.searchIcon} />
                            <input
                                type="text"
                                placeholder={`Search ${activeTab} ...`}
                                value={searchTerm}
                                onChange={handleSearchChange} />

                        </div> */}
                        <div className={ classes.user }>

                            <h3 className={ classes.sectionTitle }>{ activeTab }</h3>
                            {
                                // activeTab === 'RFQ' ? Object.entries(final_data).map(([key, value], index) => {
                                activeTab === 'RFQ'
                                    ? Object.entries(final_data)
                                        .sort((a, b) => {
                                            const lastA = a[1][0]?.messages?.at(-1)?.created ?? "";
                                            const lastB = b[1][0]?.messages?.at(-1)?.created ?? "";

                                            const dateA = new Date(lastA.replace(" - ", " "));
                                            const dateB = new Date(lastB.replace(" - ", " "));

                                            return dateB - dateA;
                                        })
                                        .map(([key, value]) => {

                                            return (
                                                <div key={ key } className={ classes.rfqSection }>
                                                    <h3 className={ classes.rfqHeader } onClick={ () => toggleAccordion(key) }>
                                                        RFQ_{ key }
                                                        <span>{ openRFQs.includes(key) ? ">" : "<" }</span>
                                                    </h3>

                                                    { openRFQs.includes(key) && (
                                                        <div className={ classes.rfqContent }>
                                                            { value.map((person) => {
                                                                return (
                                                                    <div
                                                                        key={ `${key}_${person.user}` }
                                                                        className={ `${classes.chatuser} ${selectedchat?.user === person.user ? classes.active : ""}` }
                                                                        onClick={ () => handlerespectiveChat(person, person.sender_token, person.receiver_token, person.rfq_id) }

                                                                    >
                                                                        <div className={ classes.avatarCircle }>
                                                                            <h3>{ person.name.charAt(0).toUpperCase() }</h3>
                                                                        </div>
                                                                        <div className={ classes.chatuserinfo }>
                                                                            <h3>{ person.name.toUpperCase() }</h3>
                                                                            <p>{ person.designation }</p>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            }) }
                                                        </div>
                                                    ) }
                                                </div>
                                            )
                                        }) : (filteredUsers.length > 0 && (
                                            filteredUsers.map((person) => (
                                                <div
                                                    key={ person.id }
                                                    className={ `${classes.chatuser} ${selectedchat?.id === person.id ? classes.active : ""}` }
                                                    onClick={ () => handlerespectiveChat(person) }
                                                >
                                                    <div className={ classes.avatarCircle }>
                                                        <h3>{ person.first_name.charAt(0).toUpperCase() }</h3>
                                                    </div>
                                                    <div className={ classes.chatuserinfo }>
                                                        <h3>{ person.first_name.toUpperCase() }</h3>
                                                        {/* <span>{person.company_name}</span> */ }
                                                        <p>{ person.designation }</p>
                                                    </div>
                                                </div>
                                            ))
                                        ))
                            }
                        </div>
                    </div>
                </div>

                <div className={ classes.chatwindow }>
                    { selectedchat ? <div className={ classes.messageconatiner }>

                        <div className={ classes.chatheaderwrapper }>
                            <div className={ classes.userheader }>

                                <div className={ classes.avatarCircle }>
                                    <p>{
                                        selectedchat?.first_name.charAt(0).toUpperCase()
                                    }</p>
                                </div>
                                <h3>{
                                    selectedchat?.first_name.toUpperCase()
                                }</h3>
                            </div>

                            {/* <div>
                                <button
                                    // onClick={handleDownloadChat}
                                    className={`${classes.downloadButton} ${isDownloading ? classes.downloading : ""}`}
                                    disabled={isDownloading}
                                >
                                    {isDownloading ? "Downloading..." : "Download Chat"}
                                </button>
                            </div> */}
                        </div>

                        <div className={ classes.chatmessages }>
                            { conversationMessages.length > 0 ? (
                                conversationMessages.map((msg, index) => {
                                    return (
                                        <div
                                            key={ index }
                                            className={ `${classes.messagewrapper} ${msg.isSender ? classes.sentwrapper : classes.receivedwrapper}` }
                                        >
                                            { !msg.isSender && (
                                                <div className={ classes.avatarCircle }>
                                                    <h3>
                                                        { selectedchat?.first_name
                                                            ? selectedchat.first_name.charAt(0).toUpperCase()
                                                            : "?" }
                                                    </h3>
                                                </div>
                                            ) }

                                            <div className={ `${classes.message} ${msg.isSender ? classes.sent : classes.received}` }>
                                                <p>{ msg.message }</p>
                                                <span>

                                                    { msg.document && msg.document.length > 0 ? <AttachmentList item={ msg } /> : '' }

                                                    { msg.attachment && (

                                                        <a href={ msg.attachment } target="_blank" rel="noopener noreferrer">
                                                            📎 { msg.fileName || "View Attachment" }
                                                        </a>

                                                    ) }
                                                </span>
                                                <p>{ msg.created }</p>
                                            </div>

                                            { msg.isSender && (
                                                <div className={ classes.avatarCircle }>
                                                    <h3>{ loginData?.user?.first_name.charAt(0).toUpperCase() }</h3>
                                                </div>
                                            ) }
                                        </div>
                                    )
                                })
                            ) : (
                                <div className={ classes.nomessages }>

                                </div>
                            ) }
                        </div>

                        <div className={ classes.chatinput }>
                            {/* File Upload Icon */ }
                            <div>
                                <label htmlFor="fileUpload">
                                    <AttachEmail sx={ { fontSize: 25 } } color="primary" />
                                </label>
                                <input
                                    id="fileUpload"
                                    type="file"
                                    style={ { display: "none" } }
                                    onChange={ (e) => {
                                        const file = e.target.files[0];
                                        setUserInput({
                                            ...getuserinput,
                                            file: file,
                                            fileName: file ? file.name : "", // Store file name
                                        });
                                    } }
                                />
                            </div>

                            {/* Display Selected File Name */ }
                            { getuserinput.fileName && (
                                <div className={ classes.filePreview }>
                                    <p>📎 { getuserinput.fileName }</p>
                                </div>
                            ) }

                            {/* Message Input Field */ }
                            <div className={ classes.inputwrapper }>
                                <input
                                    type="text"
                                    placeholder="Type a message..."
                                    value={ getuserinput.message }
                                    onChange={ handleUserMessageInput }
                                    onKeyDown={ (e) => e.key === "Enter" && handleUserSendMessage() }
                                />
                                <button onClick={ handleUserSendMessage }>Send</button>
                            </div>
                        </div>


                    </div> :
                        <div className={ classes.emptychatmessage }>
                            <div className={ classes.emptyState }>
                                <ForumOutlined className={ classes.emptyIcon } />
                                <h3>Select a chat to start messaging</h3>
                                <p>
                                    Choose from your existing conversations or start a new one
                                </p>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>

    )



}

export default Chat_System;